import React, { ReactNode } from "react";
import { classNamesList } from "../../../../common/utils/class-name";
import { formatText } from "../../../helper/formatText";
import { Typography } from "@mui/material";

interface INotificationBannerProps {
    children: ReactNode;
    onHide: () => void;
}

interface ISuccessNotificationBannerProps extends INotificationBannerProps {
    success: true;
    error?: false;
}

interface IErrorNotificationBannerProps extends INotificationBannerProps {
    error: true;
    success?: false;
}

export const NotificationBanner = (props: ISuccessNotificationBannerProps | IErrorNotificationBannerProps) => {
    const handleEnterAnimationEnd = (event: React.AnimationEvent<HTMLElement>) =>
        event.currentTarget.dataset.animationStage = "leave";
    const handleLeaveAnimationEnd = () =>
        props.onHide();

    const handleAnimationEnd = (event: React.AnimationEvent<HTMLElement>) =>
        event.currentTarget.dataset.animationStage === "enter" ? handleEnterAnimationEnd(event) : handleLeaveAnimationEnd();

    return React.Children.map(props.children, (el =>
        React.isValidElement(el)  ?
            React.cloneElement(el, {
                ...el.props,
                onAnimationEnd: handleAnimationEnd,
                dataset: {
                    animationStage: "enter",
                },
                className: classNamesList([el.props.className ?? "", `notification-banner notification-${props.success ? "success" : "error"}`]),
                children: !React.isValidElement(el.props.children) ?
                    formatText(el.props.children as string) : el.props.children,
            }) : el && <Typography className={`notification-banner notification-${props.success ? "success" : "error"}`}
                                   onAnimationEnd={handleAnimationEnd}
                                   data-animation-stage={"enter"}>
            {formatText(el as string)}
    </Typography>));
};
